import React, { memo, useCallback } from 'react';
import { useQueryClient } from 'react-query';
import { useSelector } from 'react-redux';
import Attachments from '../../../../components/attachments/Attachments/Attachments';
import request from '../../../../helpers/request';
import queries from '../../queries/queries';
import deleteCounterpartyAttachment from '../../requests/deleteCounterpartyAttachment';
import downloadCounterpartyAttachment from '../../requests/downloadCounterpartyAttachment';

const CounterpartiesAttachments = ({ counterparty }) => {
  const queryClient = useQueryClient();

  const userCanEdit = useSelector(
    (store) => store.authentication.userInfo.CanCreateOffice
  );

  const userCanDelete = useSelector(
    (store) => store.authentication.userInfo.CanDeleteOffice
  );

  const downloadAttachment = useCallback((...args) => {
    downloadCounterpartyAttachment(...args);
  }, []);

  const deleteAttachment = useCallback(
    async (attachmentId) => {
      await deleteCounterpartyAttachment(attachmentId, counterparty);
    },
    [counterparty]
  );

  const getAttachments = useCallback(
    async (_id, update) => {
      if (update) {
        await queryClient.invalidateQueries(queries.counterparties);
      }

      return counterparty.attachments || [];
    },
    [queryClient, counterparty]
  );

  const getPreviewAttachment = useCallback(async (counterpartyId, fileName) => {
    const response = await request.get(
      `/RentPlace/counterparty/${counterpartyId}/attachment`,
      {
        fileName,
      }
    );
    if (response) {
      const data = Buffer.from(response, 'base64');
      return window.URL.createObjectURL(new Blob([data]));
    } else return null;
  }, []);

  return (
    <Attachments
      getPreviewAttachment={getPreviewAttachment}
      hideUploadBox={!userCanEdit}
      getAttachments={getAttachments}
      parentId={+counterparty.id}
      pageSize={3}
      allowedDeleteAnyAttachment={userCanDelete}
      postUrl={`/RentPlace/counterparty/${counterparty.id}/attachment`}
      downloadAttachment={downloadAttachment}
      deleteAttachment={deleteAttachment}
      textStyles={{ width: 'calc(100% - 27px)' }}
    />
  );
};

export default memo(CounterpartiesAttachments);
